export default __webpack_public_path__ + "e63804782988ade7c70e665d93fd79a3.png";